import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {LoginService} from '../services/login.service';
import {User} from '../services/model/user';
import {ModalHelper} from '../services/modalService/modal.helper';
import {Subscription} from 'rxjs/Subscription';
import {EventService} from '../services/event.service';
import {PaypalService} from '../services/paypal.service';
import {ApiService} from '../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {DatePipe} from '@angular/common';
import * as $ from 'jquery';
import {GoogleAnalyticsService} from "../services/google-analytics-service";
import {ModalService} from "../services/modalService/modal.service";
import {GenericModalComponent} from "../generic-modal/generic-modal.component";
import {UtilsService} from "../services/utils.service";
import { TranslateService } from '@ngx-translate/core';

let curId = 0; // counter for paypal form, since we use it in different areas of same page

@Component({
    selector: 'app-paypal',
    templateUrl: './paypal.component.html',
    styleUrls: ['./paypal.component.css']
})
export class PaypalComponent implements OnInit, OnDestroy {
    @Input()
    public isAdvanced = false;
    @Input()
    public isAdvancedSinglePayment = false;
    @Input()
    public isPremium = false;
    @Input()
    public isPremiumSinglePayment = false;
    @Input()
    public isUnsubscribe = false;
    private isFree = true;
    public isDisabled = false;
    public currentUser: User;
    public label: string;
    public curFormId;
    private subscription: Subscription;

    constructor(private apiService: ApiService,
                private eventService: EventService,
                private ga: GoogleAnalyticsService,
                private loginService: LoginService,
                private modalHelper: ModalHelper,
                private modalService: ModalService,
                private utilsService: UtilsService,
                private notificationService: NotificationsService,
                private paypalService: PaypalService,
                private translate: TranslateService) {
        this.curFormId = 'paypal_form_' + curId++;
        this.currentUser = this.loginService.getCurrentUser();
        this.subscription = this.eventService.getMessage().subscribe((event) => {
            if (event.type === 'user') {
                this.currentUser = event.data;
            }
        });
    }

    ngOnInit() {
        this.computeLabel();
        this.loginService.isLoggedIn()
            .subscribe((user) => {
                if (user) {
                    this.currentUser = user;
                    // this.label = this.computeLabel();
                    this.isDisabled = this.computeDisabled();
                }
            }, (error) => {

            });
        if (this.isAdvanced || this.isAdvancedSinglePayment || this.isPremium || this.isPremiumSinglePayment || this.isUnsubscribe) {
            this.isFree = false;
        }
    }

    private computeLabel(): void {
        if (this.isPremium) {
        	if (!this.currentUser.isLoggedIn) {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            } else {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            }
        } else if (this.isPremiumSinglePayment) { 
            if (!this.currentUser.isLoggedIn) {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            } else {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            }
        } else if (this.isAdvanced) { 
            if (!this.currentUser.isLoggedIn) {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            } else {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            }
        } else if (this.isAdvancedSinglePayment) { 
            if (!this.currentUser.isLoggedIn) {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            } else {
            	this.translate.get('layout.buyIt').subscribe(res => this.label = res)
            }
        } else if (this.isUnsubscribe) {
            this.label = 'Unsubscribe';
        } else {
            this.translate.get('layout.buyIt').subscribe(res => this.label = res)
        }
    }

    public processAction() {
        if (this.isPremium) {
        	if (!this.currentUser.isLoggedIn) {
        		this.ga.emitEvent('Pricing', 'Try It Premium Subscription', 'Click');
	            this.goCreateAccount();
	        } else {
	        	 return this.goPremium();
	        }
        } else if (this.isPremiumSinglePayment) {
        	if (!this.currentUser.isLoggedIn) {
        		this.ga.emitEvent('Pricing', 'Try It Premium Single Payment', 'Click');
	            this.goCreateAccount();
	        } else {
            	return this.goPremiumSinglePayment();
            }
        } else if (this.isAdvanced) {
        	if (!this.currentUser.isLoggedIn) {
        		this.ga.emitEvent('Pricing', 'Try It Advanced Subscription', 'Click');
	            this.goCreateAccount();
	        } else {
            	return this.goAdvanced();
            }
        } else if (this.isAdvancedSinglePayment) {
        	if (!this.currentUser.isLoggedIn) {
        		this.ga.emitEvent('Pricing', 'Try It Advanced Single Payment', 'Click');
	            this.goCreateAccount();
	        } else {
            	return this.goAdvancedSinglePayment();
            }
        } else if (this.isUnsubscribe) {
        	if (!this.currentUser.isLoggedIn) {
	            this.goCreateAccount();
	        } else {
	        	return this.goUnsubscribe();
	        }
        } else if (!this.currentUser.isLoggedIn) {
        	this.ga.emitEvent('Pricing', 'Try It Basic', 'Click');
            this.goCreateAccount();
        }
    }

    private goCreateAccount() {
        this.modalHelper.openCreate({}, null);
    }

    private goAdvanced() {
        this.ga.emitEvent('Pricing', 'Buy It Advanced Subscription', 'Click');
        this.paypalService.getAdvancedButton(false).subscribe((button) => {
            // window.open(button);
            this.createAndSubmitPayPalForm(button);
        }, (err) => {
            const msg = this.apiService.getMessageFromError(err,
                'Unexpected error of PayPal Advanced. Please try again or contact suppor@openlm.com if error persists.');
            this.notificationService.error(this.translate.instant('common.error'), msg);
        });
    }
    
    private goAdvancedSinglePayment() {
        this.ga.emitEvent('Pricing', 'Buy It Advanced Single Payment', 'Click');
        this.paypalService.getAdvancedButton(true).subscribe((button) => {
            // window.open(button);
            this.createAndSubmitPayPalFormSinglePayment(button);
        }, (err) => {
            const msg = this.apiService.getMessageFromError(err,
                'Unexpected error. Please try again or contact suppor@openlm.com if error persists.');
            this.notificationService.error(this.translate.instant('common.error'), msg);
        });
    }

    private goPremium() {
        this.ga.emitEvent('Pricing', 'Buy It Premium Subscription', 'Click');
        this.paypalService.getPremiumButton(false).subscribe((button) => {
            // window.open(button);
            this.createAndSubmitPayPalForm(button);
        }, (err) => {
            const msg = this.apiService.getMessageFromError(err,
                'Unexpected error. Please try again or contact suppor@openlm.com if error persists.');
            this.notificationService.error(this.translate.instant('common.error'), msg);
        });
    }
    
    private goPremiumSinglePayment() {
        this.ga.emitEvent('Pricing', 'Buy It Premium Single Payment', 'Click');
        this.paypalService.getPremiumButton(true).subscribe((button) => {
            // window.open(button);
            this.createAndSubmitPayPalFormSinglePayment(button);
        }, (err) => {
            const msg = this.apiService.getMessageFromError(err,
                'Unexpected error. Please try again or contact suppor@openlm.com if error persists.');
            this.notificationService.error(this.translate.instant('common.error'), msg);
        });
    }

    private createAndSubmitPayPalForm(payPalButton: any) {
//        String paypalUrl = String.format("%s?cmd=_xclick-subscriptions"
//                + "&business=%s"
//                + "&item_name=%s&item_number=openlm-parser-premium"
//                + (trialDays > 0 ? "&a1=0&p1=" + trialDays + "&t1=D" : "")
//                + "&a3=" + PayPalBusiness.PREMIUM_PRICE + "&p3=1&t3=M"
//                + "&src=1&srt=12&no_shipping=1"
//                + "&custom=%s&notify_url=%s"
//                + "&return=%s&cancel_return=%s",
//            Config.instance.getPayPalUrl(),
//            Config.instance.getPayPalMerchantId(),
//            itemDescription,
//            email,
//            notifyURL,
//            returnURL,
//            returnURL);
        const parserFormIdSel = '#' + this.curFormId;
        // console.log(parserFormIdSel);
        // console.log(document.getElementById(parserFormIdSel));
        // console.log(payPalButton.payPalUrl);
        // attrs
        // console.log(payPalButton);
        $(parserFormIdSel).attr('action', payPalButton.payPalUrl);
        // $(parserFormId).attr('action', '/test1');

        // inputs
        // Get the value from a checked checkbox
        $(parserFormIdSel + ' input[name=cmd]').val(payPalButton.cmd);
        $(parserFormIdSel + ' input[name=business]').val(payPalButton.business);
        $(parserFormIdSel + ' input[name=item_name]').val(payPalButton.itemName);
        $(parserFormIdSel + ' input[name=item_number]').val(payPalButton.itemNumber);

        function addDynamicField(form, name, value) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', name);
            hiddenField.setAttribute('value', value);
            form.appendChild(hiddenField);
        }

        // make sure trial inputs are not attached
        $(parserFormIdSel + ' input[name=a1]').remove();
        $(parserFormIdSel + ' input[name=p1]').remove();
        $(parserFormIdSel + ' input[name=t1]').remove();

        if (payPalButton.p1 > 0) {
            // attach trial inputs
            const formElem = document.getElementById(this.curFormId);
            addDynamicField(formElem, 'a1', payPalButton.a1);
            addDynamicField(formElem, 'p1', payPalButton.p1);
            addDynamicField(formElem, 't1', payPalButton.t1);
        }

        $(parserFormIdSel + ' input[name=a3]').val(payPalButton.a3);
        $(parserFormIdSel + ' input[name=p3]').val(payPalButton.p3);
        $(parserFormIdSel + ' input[name=t3]').val(payPalButton.t3);

        $(parserFormIdSel + ' input[name=src]').val(payPalButton.src);
        $(parserFormIdSel + ' input[name=srt]').val(payPalButton.srt);
        $(parserFormIdSel + ' input[name=no_shipping]').val(payPalButton.noShipping);
        $(parserFormIdSel + ' input[name=custom]').val(payPalButton.custom);
        $(parserFormIdSel + ' input[name=notify_url]').val(payPalButton.notifyUrl);
        $(parserFormIdSel + ' input[name=return]').val(payPalButton.returnUrl);
        $(parserFormIdSel + ' input[name=cancel_return]').val(payPalButton.returnUrl);

        // console.log($(parserFormIdSel).attr('name'));
        // console.log($(parserFormIdSel).attr('action'));
        // console.log($(parserFormIdSel).attr('target'));

        $(parserFormIdSel).submit();
    }
    
    private createAndSubmitPayPalFormSinglePayment(payPalButton: any) {
        const parserFormIdSel = '#' + this.curFormId;
        //console.log(parserFormIdSel);
        //console.log(document.getElementById(parserFormIdSel));
        //console.log(payPalButton.payPalUrl);
   
        //console.log(payPalButton);

        // inputs
        // Get the value from a checked checkbox
        $(parserFormIdSel).attr('action', payPalButton.payPalUrl);
        $(parserFormIdSel + ' input[name=cmd]').val(payPalButton.cmd);
        $(parserFormIdSel + ' input[name=business]').val(payPalButton.business);
        $(parserFormIdSel + ' input[name=item_name]').val(payPalButton.itemName);
        $(parserFormIdSel + ' input[name=item_number]').val(payPalButton.itemNumber);

        function addDynamicField(form, name, value) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', name);
            hiddenField.setAttribute('value', value);
            form.appendChild(hiddenField);
        }
        
        $(parserFormIdSel + ' input[name=amount]').val(payPalButton.a3);
        $(parserFormIdSel + ' input[name=no_shipping]').val(payPalButton.noShipping);
        $(parserFormIdSel + ' input[name=bn]').val("PP-BuyNowBF");
        $(parserFormIdSel + ' input[name=custom]').val(payPalButton.custom);
        $(parserFormIdSel + ' input[name=notify_url]').val(payPalButton.notifyUrl);
        $(parserFormIdSel + ' input[name=return]').val(payPalButton.returnUrl);
        $(parserFormIdSel + ' input[name=cancel_return]').val(payPalButton.returnUrl);

        //console.log($(parserFormIdSel).attr('name'));
        //console.log($(parserFormIdSel).attr('action'));
        //console.log($(parserFormIdSel).attr('target'));

        $(parserFormIdSel).submit();
    }

    private doUnsubscribe() {
        this.paypalService.unsubscribe().subscribe((subscriptionStatus) => {
            const dateString = new DatePipe('en-US').transform(subscriptionStatus.paidTo, 'medium');
            const subscriptionLevel = subscriptionStatus.type;
            const article = this.utilsService.isVowel(subscriptionLevel) ? 'an' : 'a';
            const daysLeft = subscriptionStatus.daysLeft;
            this.notificationService.warn(this.translate.instant('msgs.subsCanceled'), this.translate.instant('msgs.subsMsg', {article, subscriptionLevel, daysLeft, dateString} ));
                // `You are currently subscribed to ${article} ${subscriptionLevel} membership plan. `
                // + `Your subscription is valid for ${daysLeft} more days and expires on ${dateString} UTC.`);

        }, (err) => {
            const msg = this.apiService.getMessageFromError(err,
                'Error cancelling your subscription. Please try again or contact suppor@openlm.com if error persists.');
            this.notificationService.error(this.translate.instant('common.error'), msg);
        });
    }

    private goUnsubscribe() {
        this.modalService.open(GenericModalComponent, {
            title: this.translate.instant('pricing.unsubscribePlanTitle'),
            data: {
                message: this.translate.instant('pricing.unsubscribePlan'),
            	order : 0,
            	addFooterBtn : true,
            	isCancel: true,
                centered: true
            },

        }).subscribe((result) => {
            // console.log(result);
            if(result){
                this.doUnsubscribe();
            }
        });
    }

    private loginPrompt() {
        this.modalHelper.openLogin({});
    }

    computeDisabled() {
        if(!this.currentUser.paid || (!this.currentUser.paid && this.currentUser.paidTo))
        {
            return false;
        }
        
        if (this.currentUser.isLoggedIn) {
            if (this.isPremium && this.currentUser.subscribed && this.currentUser.premium) {
                return true;
            } else if (this.isAdvanced && this.currentUser.subscribed) {
                return true;
            } else if (this.isAdvancedSinglePayment && this.currentUser.subscribed) {
                return true;
            } else if (this.isUnsubscribe && !this.currentUser.subscribed) {
                return true;
            } else if (this.isFree) {
                return true;
            }
            return false;
        } else {
            return false;
        }
    }

    getClassForDisabled() {
        if (this.isDisabled) {
            return 'plan-grey';
        }
        return '';
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/paypal/paypal.component.ts